import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VeeValidateLaravel from 'vee-validate-laravel';

const config = {
    errorBagName: 'formErrors',
};

export default () => {
    Vue.use(VeeValidate, config);
    Vue.use(VeeValidateLaravel);
};
